import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import styled, { css } from "styled-components";
import { executeTaggeo } from "../../../store/actions";
import { ClaroSDKService } from "../../../services/sdk/ClaroSDKService";

const Container = styled.div`
    ${props => props.$isContainerTelcel && 
		css`
            margin: 15px 3% 0px 3%;
		`
	}

	${props => !props.$isContainerTelcel && 
		css`
			margin: 15px 3% 0px 3%;
		`
    }
`;

const Img = styled.img`
    ${props => props.$isContainerTelcel && 
		css`
            max-width: 100%;
		`
	}

	${props => !props.$isContainerTelcel && 
		css`
            max-width: 100%;
		`
    }
`;

const AdvanceMegas = ({ userInfo, isContainerTelcel, originParamValue, executeTaggeo }) => {
    React.useEffect(() => {
        let origen = originParamValue ? originParamValue.split(",") : "";
            origen = origen && origen[1] ? origen[1] : "";
        const params = {
            eventName: "adelanta_megas",
            seccion: "consulta megas",
            subseccion: "",
            origen: origen ? decodeURIComponent(atob(origen)) : "",
            impresionBanners: 1,
            banners: [{
                type: "unico",
                position: 1,
                ubication: "medio",
                categoria: "consulta megas",
                nombreElemento: getBannerName(userInfo.advance.banners.web),
            }],
            pantalla: getBannerName(userInfo.advance.banners.web),
            trackState: true,
        };

        executeTaggeo(params, true);
    }, []);

    const getBannerName = (banner) => {
        const srcMatch = banner.match(/src=["']([^"']+)["']/);
        const url = srcMatch ? srcMatch[1] : banner;
        const bannerName = url.split('/').pop() || '';
        const bannerNameWithoutExtension = bannerName.replace(/\.[^/.]+$/, '');

        return bannerNameWithoutExtension;
    }

    const handleOnClick = () => {
        const bannerName = getBannerName(userInfo.advance.banners.web);
        ClaroSDKService.openTelcelAdvance(bannerName);

        let origen = originParamValue ? originParamValue.split(",") : "";
            origen = origen && origen[1] ? origen[1] : "";
        const params = {
            eventName: "adelanta_megas",
            seccion: "consulta megas",
            subseccion: "",
            origen: origen ? decodeURIComponent(atob(origen)) : "",
            clicBanners: 1,
            banners: [{
                type: "unico",
                position: 1,
                ubication: "medio",
                categoria: "consulta megas",
                nombreElemento: bannerName,
            }],
            pantalla: bannerName,
            trackAction: true,
        }
        executeTaggeo(params, true);
    }
    
    return (
        <Container 
            $isContainerTelcel={isContainerTelcel}
            onClick={handleOnClick}>
            <Img
                src={userInfo.advance.banners.web}
                alt="advance-banner"
                $isContainerTelcel={isContainerTelcel}
            />
        </Container>
    );
};

const mapStateToProps = (state) => {
    const { payments } = state;
    const userInfo = payments.userInfo;
    const isContainerTelcel = payments.isContainerTelcel;
    const originParamValue = payments.originParamValue;

    return {
        userInfo,
        isContainerTelcel,
        originParamValue,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        { executeTaggeo },
        dispatch,
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(AdvanceMegas);
